<template>
  <v-row>
    <v-col
      v-for="species in similarSpecies"
      :key="species.id"
      class="d-flex child-flex flex-wrap"
      :cols="$vuetify.breakpoint.smAndDown ? 12 : 4"
    >
      <!-- <v-card>
        <v-img
          :src="$_getImage(species.li_image_id)"
          class="white--text align-end"
          height="150px"
        >
          <v-card-title v-text="species.name_sve"></v-card-title>
        </v-img>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="orange lighten-2"
            text
            @click="
              $router.push({
                name: 'SingleSpecies',
                params: { nameUrl: species.url }
              })
            "
          >
            Utforska
            <v-icon right>
              mdi-arrow-right
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card> -->
      <SpeciesCard class="" :species="species" />
    </v-col>
  </v-row>
</template>

<script>
import Misc from '@/mixins/Misc.js'
import _sampleSize from 'lodash/sampleSize'
import SpeciesCard from '@/components/SpeciesCard.vue'

export default {
  name: 'similarSpecies',
  mixins: [Misc],
  components: { SpeciesCard },
  props: {
    species: { type: Object, required: true },
    count: { type: Number, required: true }
  },
  computed: {
    similarSpecies() {
      let speciesSimilarBySubCat = []
      let speciesSimilarByCat = []
      const res = this.$store.state.allSpecies
      speciesSimilarBySubCat = res.filter(
        species =>
          species.life_group === this.species.life_group &&
          species.id !== this.species.id &&
          species.life_group !== ''
      )
      if (speciesSimilarBySubCat.length < this.count) {
        speciesSimilarByCat = res.filter(
          species =>
            species.category === this.species.category &&
            species.id !== this.species.id
        )
      }
      return _sampleSize(
        [...speciesSimilarBySubCat, ...speciesSimilarByCat],
        this.count
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>
